import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type GetMyBettieAutoTopUpResponse =
  paths['/api/v1/bettie_auto_topups/me']['get']['responses'][200]['content']['application/json']['bettieAutoTopup'];

export type PauseBettieAutoTopUpResponse =
  paths['/api/v1/bettie_auto_topups/{uuid}/pause']['post']['responses'][200]['content']['application/json']['bettieAutoTopup'];

export type ActivateBettieAutoTopUpResponse =
  paths['/api/v1/bettie_auto_topups/{uuid}/activate']['post']['responses'][200]['content']['application/json']['bettieAutoTopup'];

export async function getMyBettieAutoTopUp(): Promise<GetMyBettieAutoTopUpResponse> {
  const { data, error } = await client.GET('/api/v1/bettie_auto_topups/me', {
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when getting my bettie auto top up');
  return data.bettieAutoTopup;
}

export async function pauseBettieAutoTopUp(
  bettieAutoTopUpId: string
): Promise<GetMyBettieAutoTopUpResponse> {
  const { data, error } = await client.POST('/api/v1/bettie_auto_topups/{uuid}/pause', {
    params: { path: { uuid: bettieAutoTopUpId } },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when pausing bettie auto top up');
  return data.bettieAutoTopup;
}

export async function activateBettieAutoTopUp(
  bettieAutoTopUpId: string
): Promise<ActivateBettieAutoTopUpResponse> {
  const { data, error } = await client.POST('/api/v1/bettie_auto_topups/{uuid}/activate', {
    params: { path: { uuid: bettieAutoTopUpId } },
    headers: authHeaders()
  });
  if (error) throw error;
  if (!data) throw new Error('Empty response when activating bettie auto top up');
  return data.bettieAutoTopup;
}